module.exports = __webpack_public_path__ + "img/home_5.b0bf1a1f.jpg";